if (!customElements.get('navigation-atc')) {
  class NavigationAtc extends HTMLElement {
    constructor() {
      super();
      this.price = this.querySelector('.navigation-atc__price');
      this.button = this.querySelector('.navigation-atc__cta');
      this.buttonText = this.querySelector('.navigation-atc__cta-text');
      this.loadingTimer = null;
      this.loadingCheck = null;
      this.variantUpdateHandler = this.handleVariantUpdate.bind(this);
      this.cartFinishedHandler = this.stopLoading.bind(this);
    }

    connectedCallback() {
      if (!this.button) return;

      this.button.addEventListener('click', () => this.handleClickOnCta());
      document.addEventListener(`eurus:product-page-variant-select:updated:${this.sectionId}`, this.variantUpdateHandler);
      document.addEventListener('eurus:cart:items-changed', this.cartFinishedHandler);
      document.addEventListener('eurus:cart:redirect', this.cartFinishedHandler);
      this.syncButtonState();
    }

    disconnectedCallback() {
      document.removeEventListener(`eurus:product-page-variant-select:updated:${this.sectionId}`, this.variantUpdateHandler);
      document.removeEventListener('eurus:cart:items-changed', this.cartFinishedHandler);
      document.removeEventListener('eurus:cart:redirect', this.cartFinishedHandler);
      this.clearLoadingTimers();
    }

    get sectionId() {
      return this.dataset.sectionId;
    }

    get targetButton() {
      const targetButtonId = this.dataset.targetButtonId;
      if (!targetButtonId) return null;
      return document.getElementById(targetButtonId);
    }

    handleClickOnCta() {
      const targetButton = this.targetButton;
      if (!targetButton || targetButton.disabled || this.button.disabled) return;

      this.startLoading();
      this.watchTargetLoading(targetButton);
      targetButton.click();
    }

    handleVariantUpdate(event) {
      const html = event.detail?.html;
      if (!html) return;

      this.renderPrice(html);
      this.syncButtonState();
    }

    renderPrice(html) {
      if (!this.price || !this.sectionId) return;

      const selectedVariant = html.querySelector('.variant-selects-main [data-selected-variant]')?.textContent;
      const variantUnavailable = selectedVariant && selectedVariant.trim() === 'null';
      const source = html.getElementById(`navigation-atc-price-${this.sectionId}`);

      if (source) {
        this.price.innerHTML = source.innerHTML;
      }

      this.price.classList.toggle('hidden', Boolean(variantUnavailable));
    }

    syncButtonState() {
      const targetButton = this.targetButton;
      const targetUnavailable = !targetButton || targetButton.disabled || targetButton.dataset.available === 'false';

      this.button.disabled = targetUnavailable;
      this.syncButtonText(targetButton);
    }

    syncButtonText(targetButton) {
      if (!this.buttonText) return;

      const targetText = targetButton?.querySelector('.x-atc-text')?.cloneNode(true);
      if (targetText) {
        targetText.querySelectorAll('.main-product-price').forEach((price) => price.remove());
      }

      const label = targetButton && targetButton.disabled ? targetText?.textContent?.replace(/\s*-\s*$/, '').trim() : this.buttonText.dataset.addLabel;
      this.buttonText.textContent = label || this.defaultButtonLabel(targetButton);
    }

    defaultButtonLabel(targetButton) {
      if (!targetButton) return this.dataset.unavailableLabel || '';
      if (targetButton.disabled || targetButton.dataset.available === 'false') return this.dataset.soldOutLabel || '';
      return this.dataset.addLabel || '';
    }

    startLoading() {
      this.button.classList.add('is-loading');
      this.button.setAttribute('aria-busy', 'true');
      this.button.disabled = true;
      this.clearLoadingTimers();
    }

    stopLoading() {
      this.clearLoadingTimers();
      this.button.classList.remove('is-loading');
      this.button.removeAttribute('aria-busy');
      this.syncButtonState();
    }

    clearLoadingTimers() {
      clearTimeout(this.loadingTimer);
      clearInterval(this.loadingCheck);
      this.loadingTimer = null;
      this.loadingCheck = null;
    }

    watchTargetLoading(targetButton) {
      const data = this.getAlpineData(targetButton);
      let sawLoading = false;

      this.loadingCheck = setInterval(() => {
        const targetLoading = Boolean(data?.loading || window.updatingCart);
        sawLoading = sawLoading || targetLoading;

        if (sawLoading && !targetLoading) {
          this.stopLoading();
        }
      }, 100);

      this.loadingTimer = setTimeout(() => this.stopLoading(), 12000);
    }

    getAlpineData(targetButton) {
      if (!window.Alpine || typeof window.Alpine.$data !== 'function') return null;

      let alpineRoot = targetButton.closest('[x-data]');
      while (alpineRoot) {
        const data = window.Alpine.$data(alpineRoot);
        if (data && ('loading' in data || typeof data.addToCart === 'function')) return data;
        alpineRoot = alpineRoot.parentElement?.closest('[x-data]');
      }

      return null;
    }
  }

  customElements.define('navigation-atc', NavigationAtc);
}
